(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PainelCriarMapaCtrl', PainelCriarMapa);

  PainelCriarMapa.$inject = [
    '$scope',
    'HistoricoMapasService',
    'LoadingService',
    'MessagesService',
    '$q',
    '$filter'
  ];

  function PainelCriarMapa($scope, HistoricoMapasService, LoadingService,
                           MessagesService, $q, $filter) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.newMap = {
      gleba: null,
      data: null,
      tipo: null,
      descricao: null,
      shape: null,
      field: null,
      imagem_attributes: null,
    };
    vm.types = [];
    vm.shapeFields = [];
    vm.datePicker = {
      open: false,
      options: {
        showWeeks: false
      },
      format: 'dd/MM/yyyy'
    };
    vm.tempFile = null;
    vm.loadingShape = false;
    vm.loadingSave = false;

    //////////////////////////////////////////
    // Bindable methods
    vm.processFile = processFile;
    vm.canSave = canSave;
    vm.canCancel = canCancel;
    vm.save = save;
    vm.cancel = cancel;

    //////////////////////////////////////////
    // Function declarations

    function processFile() {
      /** @type File */
      const file = vm.tempFile;
      vm.shapeFields = [];
      if (file) {
        vm.loadingShape = true;
        if (file.name.match(/\.zip$/)) {
          return fileToBase64(file)
            .then((result) => {
              vm.newMap.shape = result.match(/,(\S+)/)[1];
              vm.newMap.imagem_attributes = null;
              return HistoricoMapasService.processShape(vm.newMap.shape);
            })
            .then(({ data }) => {
              vm.shapeFields = data;
            })
            .catch((error) => {
              console.error(error);
              MessagesService.alert('Erro ao processar arquivo Shape informado.');
              vm.tempFile = null;
            })
            .finally(() => {
              vm.loadingShape = false;
            });
        }
        fileToBase64(file)
          .then((result) => {
            vm.newMap.shape = null;
            vm.newMap.imagem_attributes = {
              imagem_data: result,
            };
            vm.loadingShape = false;
          });
      }
    }

    function fileToBase64(file) {
      const reader = new FileReader();
      return $q((resolve, reject) => {
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    }

    function canSave() {
      return !vm.loadingShape &&
             !vm.loadingSave &&
             $scope.mapaForm.$valid;
    }

    function canCancel() {
      return !vm.loadingShape && !vm.loadingSave;
    }

    function cancel() {
      $scope.$emit('activateSidebar', 'historyMapListing');
    }

    function save() {
      vm.loadingSave = true;
      const data = Object.entries(vm.newMap).filter(([, value]) => !!value).reduce((obj, [key, value]) => {
        if (key === 'gleba') {
          obj.gleba_id = value.id;
        } else if (key === 'data') {
          obj.data = moment(value).format(MOMENT_DATE_ENGLISH_FORMAT);
        } else if (key === 'tipo') {
          obj.tipo = value.id;
        } else {
          obj[key] = value;
        }
        return obj;
      }, {});

      HistoricoMapasService.saveMap(data)
        .then(() => {
          $scope.$emit('activateSidebar', 'historyMapListing');
        })
        .catch((error) => {
          console.error(error);
          MessagesService.alert('Falha ao salvar o mapa. Tente novamente.');
        })
        .finally(() => {
          vm.loadingSave = false;
        });
    }

    //////////////////////////////////////////
    // Controller logic

    $scope.$root.initialize.then(() => {
      LoadingService.showLoading();
      return HistoricoMapasService.listTypes();
    }).then((typesResponse) => {
      vm.types = (typesResponse.data || []).filter((type) => type.id !== 'pragas');
    }).catch((error) => {
      console.error(error);
      MessagesService.alert('Não foi possível buscar informações.');
    }).finally(LoadingService.hideLoading);

    $scope.$watchGroup([
      'mapa.newMap.gleba',
      'mapa.newMap.field',
      'mapa.newMap.tipo',
      'mapa.newMap.data'
    ], () => {
      if ($scope.mapaForm.descricao.$pristine) {
        const values = [];
        if (vm.newMap.tipo) {
          values.push(vm.newMap.tipo.descricao);
        }
        if (vm.newMap.gleba) {
          values.push(vm.newMap.gleba.descricao);
        }
        if (vm.newMap.field) {
          values.push($filter('capitalize')(vm.newMap.field));
        }
        if (vm.newMap.data) {
          values.push($filter('date')(vm.newMap.data, 'dd/MM'));
        }
        vm.newMap.descricao = values.join(' - ');
      }
    });
  }
}());
